import { createIntlCache, createIntl } from "react-intl";

const appContainerNode =
  document?.querySelector("[data-react-app]") ||
  document?.querySelector("[data-react-admin-app]");

const appContainerData = appContainerNode
  ? JSON.parse(appContainerNode.dataset.reactProps)
  : { locale: "fr", defaultLocale: "fr", translations: {} };

// Fetch locale from DOM, as it's the only mean for now to fetch it
const { locale, defaultLocale, translations } = appContainerData;

// This is optional but highly recommended
// since it prevents memory leak
const cache = createIntlCache();
const intl = createIntl({ locale, defaultLocale, messages: translations }, cache);

const translate = (...args) => {
  return intl.formatMessage(...args);
};

export { translate, intl, locale, defaultLocale };
